import ES from './flags/es.svg';
import EN from './flags/en.svg';

const langs = [
    { name: 'Español', shortname: 'es', flag: ES },
    { name: 'English', shortname: 'en', flag: EN },
];

export default langs;
